import gql from "graphql-tag";

export const UPDATE_IBKR_CREDENTIAL = gql`
  mutation UpdateIBKRCredential($companyId: ID!, $newEmail: String!, $orderId: ID!) {
    updateIBKRCredential(companyId: $companyId, newEmail: $newEmail, orderId: $orderId) {
      Status
      Errors
    }
  }
`;
